<template>
  <dialog-v2
    :show="show"
    :title="title"
    max-width="480px"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex md6 pr-4>
          <v-text-field
            v-model="form.delinquency_start"
            v-validate="'required|integer'"
            data-vv-name="delinquency_start"
            data-vv-scope="workflowStage"
            data-vv-as="inicio de mora"
            label="Inicio de mora"
            color="black"
            :error-messages="errors.collect('workflowStage.delinquency_start')"/>
        </v-flex>
        <v-flex md6 pl-4>
          <v-text-field
            v-model="form.delinquency_end"
            v-validate="`required|integer|min_value:${form.delinquency_start}`"
            data-vv-name="delinquency_end"
            data-vv-scope="workflowStage"
            data-vv-as="fin de mora"
            label="Fin de mora"
            color="black"
            :error-messages="errors.collect('workflowStage.delinquency_end')"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md5 offset-md3>
          <v-text-field
            v-model="form.days_off"
            v-validate="'required|integer'"
            data-vv-name="days_off"
            data-vv-scope="workflowStage"
            data-vv-as="ventana de tiempo"
            label="Ventana de tiempo"
            color="black"
            :error-messages="errors.collect('workflowStage.days_off')"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    stage: {
      type: Object,
      required: false,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      delinquency_start: '',
      delinquency_end: '',
      days_off: '',
    };
    return {
      emptyForm,
      form: {
        ...emptyForm,
      },
    };
  },
  computed: {
    title() {
      return `${!Object.keys(this.stage).length ? 'Crear' : 'Editar'} etapa`;
    },
  },
  methods: {
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, 'workflowStage');
      });
    },
    save() {
      this.$validator.validateAll('workflowStage').then((validation) => {
        if (validation) {
          if (Object.keys(this.stage).length) {
            this.axios.patch(`stages/${this.stage.id}`, this.form)
              .then((response) => {
                this.$emit('updated', response.data);
                this.$emit('close');
              });
          } else {
            this.axios.post(`workflows/${this.$route.params.workflow}/stages`, this.form)
              .then((response) => {
                this.$emit('created', {
                  ...response.data,
                  filters: [],
                });
                this.$emit('close');
              })
              .catch(() => {});
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.form = _.pick({
          ...this.emptyForm,
          ...this.stage,
        }, Object.keys(this.emptyForm));
        this.clearErrors();
      } else {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          this.clearErrors();
        }, 200);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/WorkflowTree/StageModal.vue